import { Format } from '@wizeoo/akm-message-lib';
import { Model } from '../../model/model';
import { DATA_KIND } from '../../model/enums';
import { FormatEngine } from '../../manager/workingdata/format.engine';
import { WizMathUtils } from '@wizeoo/akm-core-lib';
import { WizConstants } from '../../../lib/model/constants';


/**
 * VO représentant un format de mesure
 * Réduit à son minimum pour utilisation par le moteur
 */
export class FormatVO {

    constructor(pSource?: Format) {
        this._source = null;
        if (pSource) {
            this._source = pSource;
        } else {
            this._source = new Format();
            this._source.uid = WizMathUtils.createUUID(); // génération du UID si nouveau
        }
    }

    /** L'objet source provenant du back */
    protected _source: Format;

    public get source(): Format {
        return this._source;
    }
    public set source(value: Format) {
        this._source = value;
    }

    // code domaine (root), technique
    public get domain(): string {
        return this._source.domain;
    }
    public set domain(value: string) {
        this._source.domain = value;
    }

    public get businessUnitCode(): string {
        // code de la BU
        return this._source.businessUnitCode;
    }
    public set businessUnitCode(value: string) {
        this._source.businessUnitCode = value;
    }

    /**
     * code unique du format dans la bu
     */
    public set code(value: string) {
        this._source.code = value;
    }
    public get code(): string {
        return this._source.code;
    }

    // Le type de données
    public set dataKind(value: string) {
        this._source.dataKind = value;
    }
    public get dataKind(): string {
        return this._source.dataKind;
    }

    // L'expression
    public set regExp(value: string) {
        this._source.regExp = value;
    }
    public get regExp(): string {
        return this._source.regExp;
    }

    // sur [#0], pas d'affichage des 0
    public noZero: boolean = false;

    // La précision
    public precision: number = 0;

    // Le séparateur de milliers
    public thousandSeparator: string = null;

    // Le séparateur de décimales
    public decimalSeparator: string = null;

    // L'unité
    public symbol: string = null;

    // La position de l'unité
    public symbolPosition: string = 'end';

    // Est ce qu'on fait apparaitre le signe négatif ?
    public showNegativeSign: boolean = true;

    // Est ce que l'expression a été construite ?
    public partsBuilded: boolean = false; // on a pas encore construit l'expression

    // L'expression pour une date
    public dateExp: string = null;

    /** construction des parties du rendu */
    public buildParts(): void {
        if (this.regExp && this.dataKind) {
            switch (this.dataKind) {
                case DATA_KIND.INT:
                case DATA_KIND.NUMBER:
                case DATA_KIND.BOOLEAN:
                    const cleanFormulaParts = this.regExp.match(FormatEngine.ALL_PATTERN);
                    if (cleanFormulaParts) {
                        let idx: number = 1;
                        const len: number = cleanFormulaParts.length;
                        cleanFormulaParts.forEach((group: string) => {
                            // première position, si c'est un noZero
                            if (group.match(FormatEngine.NOZERO_PATTERN)) {
                                this.noZero = true;
                                // console.log('noZero');
                            }
                            // deuxième position, si c'est un symbol
                            else if (group.match(FormatEngine.SYMBOL_PATTERN)) {
                                // symbole en début ou fin uniquement
                                if (idx === 1) {
                                    // symbole en 1ere position
                                    this.symbol = group.substring(1, group.length - 1);
                                    this.symbolPosition = 'start';
                                } else if (idx === len) {
                                    // symbole en fin
                                    this.symbol = group.substring(1, group.length - 1);
                                    this.symbolPosition = 'end';
                                }
                                // console.log('symbol', group);
                            } else if (group.match(FormatEngine.NUMBER_PATTERN)) {
                                this.decimalSeparator = group.substring(1, 2);
                                this.precision = Math.max(group.length - 2, 0);
                                // console.log('decimalSeparator', group);
                            } else if (group.match(FormatEngine.THOUSAND_PATTERN)) {
                                this.thousandSeparator = group.substring(1, 2);
                                // console.log('thousandSeparator', group);
                            }
                            idx++;
                        });
                    }

                    break;
                case DATA_KIND.DATE:
                    this.dateExp = this.regExp;
                    break;
                case DATA_KIND.STRING:
                    break;
            }
            this.partsBuilded = true;
        }
    }

    /** c'est un format de base */
    public get basicFormat(): boolean {
        return this.domain === WizConstants.wildcardDomain;
    }
}
